import { afterEvent, beforeCombat, cardRef, defineGameCard } from '../authoring/index.js';
import { addGrowth, hasTrait, growthOf, isLiveOnBoard, PLANT_GROWTH_ID, photosynthesis, removeGrowth, tableOf, } from './plant-helpers.js';
export const StarBlossomCard = defineGameCard({
    id: 'star_blossom',
    gameplay: {
        type: 'UNIT', cost: 3,
        baseStats: { attack: 0, health: 5 }, traits: ['PLANT'],
    },
    presentation: {
        name: 'Звёздный цветок',
        description: 'Фотосинтез. Первый раз за раунд, когда другое ваше Растение в этой локации получает Рост, получает 1 Рост. Перед боем, если имеет не меньше 4 Роста, тратит 4, а все ваши карты в этой локации получают +2/+2.',
        glyph: {
            colors: ['#10213A', '#FECC43', '#F8A528', '#DA6C1B', '#6B6F27'],
            rows: [
                '.........11.........',
                '........1221........',
                '...11111233211111...',
                '..1433313333133331..',
                '..1422224444222241..',
                '...13233444333231...',
                '....132342243241....',
                '.....1144225411.....',
                '....142345543241....',
                '....123235522321....',
                '...1322345133221....',
                '...1344415.14441....',
                '....1111.5..111..55.',
                '5........5....5..55.',
                '.5....55.5..55..5...',
                '..5...5555.5....55.5',
                '..5....555.5.....55.',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        ...photosynthesis(),
        afterEvent({
            abilityId: 'echo_growth',
            event: 'EffectCounterChanged',
            frequency: 'first_per_round',
            when: (ctx, event) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self)
                    || event.defId !== PLANT_GROWTH_ID
                    || event.key !== 'growth'
                    || event.delta <= 0
                    || event.scope.kind !== 'unit'
                    || event.scope.instanceId === self.id)
                    return false;
                const plant = ctx.q.instance(event.scope.instanceId);
                return isLiveOnBoard(plant)
                    && plant.controllerId === self.controllerId
                    && tableOf(plant.cellId) === tableOf(self.cellId)
                    && hasTrait(ctx, plant.id, 'PLANT');
            },
            run: {
                source: 'card_effect',
                dependencies: [cardRef(PLANT_GROWTH_ID)],
                run: (ctx) => {
                    const self = ctx.self;
                    if (isLiveOnBoard(self))
                        addGrowth(ctx, self.id, 1, 'star_blossom');
                },
            },
        }),
        beforeCombat({
            source: 'card_effect',
            dependencies: [cardRef('plant_growth')],
            run(ctx) {
                const self = ctx.self;
                if (!isLiveOnBoard(self) || growthOf(ctx, self.id) < 4)
                    return;
                removeGrowth(ctx, self.id, 4, 'star_blossom');
                const cards = ctx.q.unitsOf(self.controllerId)
                    .filter((card) => card.cellId !== undefined && tableOf(card.cellId) === tableOf(self.cellId));
                for (const card of cards) {
                    ctx.ops.modifyStat(card.id, 'attack', 2, self.id);
                    ctx.ops.modifyStat(card.id, 'maxHealth', 2, self.id);
                    ctx.ops.modifyStat(card.id, 'health', 2, self.id);
                }
            },
        }),
    ],
    ui: { mechanics: ['growth', 'photosynthesis'] },
});
//# sourceMappingURL=star_blossom.js.map